module.exports = __webpack_public_path__ + "static/media/qrcode.db56b780.svg";